import types from '../../constants';

const currentDate = () => (new Date()).toTimeString().split(' ')[0];
let globalState = null;
const getNameById = (id) => {
  const state = globalState;
  // const state = global.store.getState();
  // TODO: We saw error thrown state == null sometimes, so added state guard. Why is state coming in as null, is that correct behavior?
  const users = state?.exercise?.exercise?.users;

  if (users) {
    const user = users.find(usr => usr.id === id);

    if (!user) return id;

    if (user.type == 'ORGANIZER') {
      return 'instructor (' + user.name + ')';
    } else {
      return user.name
    }
  }

  return id;
};

const getLocationNameById = (locId) => {
  // const state = global.store.getState();
  const state = globalState;
  
  const locations = state.exercise?.exercise?.scenario?.locations;

  if (locations) {
    const loc = locations.find(loc => loc.id === locId);

    if (!loc) return locId;

    let name = loc.name;

    if (loc.state) { name += ` [${loc.state}]`}
    return name;
  }

  return locId;
};


const printPlayTime = (playtime) => {
  let hrs = Math.floor(playtime / 60 / 60 / 1000);
  let mins = Math.floor(playtime / 60 / 1000) - hrs * 60;
  let secs = Math.floor(playtime / 1000) - mins * 60 - hrs * 60 * 60;

  let format = val => ("0" + val).slice(-2);
  
  if (isNaN(hrs) || isNaN(mins) || isNaN(secs)) {
    return '--:--:--';
  } else {
    return format(hrs) + ':' + format(mins) + ':' + format(secs);
  }
};

const initialState = {
  messages: [],
  exercise: {
    playtime: 0
  }
};

const LoggerReducers = (state = initialState, action) => {
  let messages;
  if(action.state) {
    globalState = action.state; 
  }

  let playCurTime = 0;
  
  if (globalState) {
    playCurTime = globalState.exercise.exercise.playTime;

    if (globalState.exercise.exercise.playStartedAt) {
      playCurTime += new Date().getTime() - globalState.exercise.exercise.playStartedAt;
    }
  } else {
    playCurTime += new Date().getTime() - state.exercise.playStartedAt;
  }

  let playtime = printPlayTime(playCurTime);
  
  const data = action.payload;
  const from = getNameById(data?.from);
  const target = data?.target && getNameById(data?.target);

  switch (action.type) {
    case types.BAD_MESSAGE:
      messages = state.messages.slice();
      
      // Used for diagnostics, in production we suppress display of it
      // messages.push(`[${playtime}] Bad message.`);

      return {
        ...state,
        messages,
      };
    case types.EXERCISE_USER_JOINED:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${action.payload.name} joined.`);

      return {
        ...state,
        messages,
      };
    case types.EXERCISE_USER_LEFT:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${getNameById(action.payload.id)} left.`);

      return {
        ...state,
        messages,
      };
    case types.EXERCISE_RENAME_USER:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${getNameById(action.payload.id)} changed name to ${action.payload.name}.`);

      return {
        ...state,
        messages,
      };
    case types.EXERCISE_USER_STATUS_CHANGE:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${getNameById(action.payload.id)} changed status to ${action.payload.status}.`);

      return {
        ...state,
        messages,
      };
    case types.EXERCISE_SET_STATE:
      messages = state.messages.slice();
      messages.push(`[${playtime}] State changed to '${action.payload || "<default state>"}'.`);

      return {
        ...state,
        messages,
      };
      
    case types.EXERCISE_LOCATION_UPDATE:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${getNameById(action.payload.id)} changed location to '${getLocationNameById(action.payload.location)}'.`);

      return {
        ...state,
        messages,
      };
      
    /**
     * don't need this as the log window gets filled in hella fast when you
     * have something like CSPic being moved around!
     * also, there is a bug in the system when a participant sets a variable, the server receives and logs
     * two messages, one from the user with the user name, and the other with the user id. The user id message
     * is related to the question in getNameById() when state comes in as null. For the time being, we just
     * suppress this issue altogether.
     * ------------------------------------------------------------------------

    case types.EXERCISE_SET_VAR:
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${getNameById(action.payload.user)} changed variable '${action.payload.key}' to '${action.payload.value}'.`);

      return {
        ...state,
        messages,
      };

    */

    case types.EXERCISE_SET_VAR_LOG:
      messages = state.messages.slice();
      if(["true", "false"].includes(action.payload.value.toString())) {
        messages.push(`[${playtime}] ${getNameById(action.payload.user)} changed variable '${action.payload.key}' to '${action.payload.value}'.`); 
      }

      return {
        ...state,
        messages,
      };

    case types.TEXT_MESSAGE:
      // const data = action.payload;
      // const from = getNameById(data.from);
      // const target = data.target && getNameById(data.target);
      // ^ Added at function scope
      // console.log("Data", data, "Parsed Target", target, "From", from);

      messages = state.messages.slice();
      messages.push(`[${playtime}] ${from}${target? ` -> ${target}` : ""}: ${data.message}`);

      return {
        ...state,
        messages,
      };
      
    case types.AUDIO_MESSAGE_STATUS:
      // const from = getNameById(data.from);
      // const target = data.target && getNameById(data.target);
      // console.log("Data", data, "Parsed Target", target, "From", from);
      console.log("Action Data:", data)
      messages = state.messages.slice();
      messages.push(`[${playtime}] ${from}: ${data.message}`);

      return {
        ...state,
        messages,
      };


    case types.LOGGER_CLEAN_LOG:
      return {
        ...state,
        messages: [],
      };
    default:
      return state;
  }
};

export default LoggerReducers;
